// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-active[data-v-421d61ba]{color:var(--v-primary-base)!important}", ""]);
// Exports
module.exports = exports;
